var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EditColumn',{attrs:{"submitText":"Update Record","title":`Edit ${_vm.recordId}`,"record":_vm.record,"error":_vm.singleError,"loading":_vm.singleStatus === 'updating'},on:{"submit":_vm.handleSubmit,"cancel":function($event){return _vm.$router.push(`/clients/${_vm.$route.params.clientId}/record/${_vm.recordId}`)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }